var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFileDoneGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4993 9.49951H2.49927V4.49951C2.49927 4.2343 2.60462 3.97994 2.79216 3.7924C2.9797 3.60487 3.23405 3.49951 3.49927 3.49951H9.05427C9.19433 3.49965 9.33279 3.52921 9.4607 3.58627C9.58861 3.64333 9.7031 3.72663 9.79677 3.83076L12.6493 6.99951H20.4993C20.7645 6.99951 21.0188 7.10487 21.2064 7.29241C21.3939 7.47994 21.4993 7.7343 21.4993 7.99951V9.49951Z",
    fill: "#239A6D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4993 6.49951H5.49927C5.22313 6.49951 4.99927 6.72337 4.99927 6.99951V15.9995C4.99927 16.2757 5.22313 16.4995 5.49927 16.4995H18.4993C18.7754 16.4995 18.9993 16.2757 18.9993 15.9995V6.99951C18.9993 6.72337 18.7754 6.49951 18.4993 6.49951Z",
    fill: "#CFFCEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4993 8.49951H3.49927C2.94698 8.49951 2.49927 8.94723 2.49927 9.49951V19.4995C2.49927 20.0518 2.94698 20.4995 3.49927 20.4995H20.4993C21.0516 20.4995 21.4993 20.0518 21.4993 19.4995V9.49951C21.4993 8.94723 21.0516 8.49951 20.4993 8.49951Z",
    fill: "#15C480"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8748 23.4995C21.4291 23.4995 23.4998 21.4288 23.4998 18.8745C23.4998 16.3202 21.4291 14.2495 18.8748 14.2495C16.3204 14.2495 14.2498 16.3202 14.2498 18.8745C14.2498 21.4288 16.3204 23.4995 18.8748 23.4995Z",
    fill: "#FFC82A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0381 20.5997L21.2523 18.0526C21.5014 17.766 21.4711 17.3318 21.1845 17.0827C20.8979 16.8335 20.4637 16.8639 20.2146 17.1505L18.0004 19.6976C17.7513 19.9842 17.7817 20.4184 18.0682 20.6675C18.3548 20.9166 18.789 20.8863 19.0381 20.5997Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0046 19.6616L17.502 18.159C17.2335 17.8905 16.7982 17.8905 16.5297 18.159C16.2612 18.4275 16.2612 18.8628 16.5297 19.1313L18.0323 20.6339C18.3008 20.9023 18.7361 20.9023 19.0046 20.6339C19.2731 20.3654 19.2731 19.9301 19.0046 19.6616Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFileDoneGreen);
export default __webpack_public_path__ + "static/media/icon_file_done_green.a8c7b2b8.svg";
export { ForwardRef as ReactComponent };